import { PropsWithChildren } from "react";
import "./Form.scss";

/**
 * Form Component
 */
export function Form({
    id,
    children,
    onSubmit,
    className,
    onKeyDown,
    tabIndex,
}: PropsWithChildren<{
    id?: string;
    onSubmit?: (data: any) => any;
    className?: string;
    onKeyDown?: (e: any) => any;
    tabIndex?: number;
}>) {
    return (
        <form
            id={id}
            onSubmit={onSubmit}
            className={`form ${className || ""}`}
            onKeyDown={onKeyDown}
            tabIndex={tabIndex}
        >
            {children}
        </form>
    );
}

/**
 * Form Columns Component
 */
Form.Columns = function Columns({
    children,
    className,
}: PropsWithChildren<{ className?: string }>) {
    return <div className={`form__columns  ${className}`}>{children}</div>;
};

/**
 * Form Column Component
 */
Form.Column = function Column({
    children,
    verticalAlignment,
}: PropsWithChildren<{ verticalAlignment?: boolean }>) {
    return (
        <div className={`form__column ${verticalAlignment ? " verticalAlignment" : ""}`}>
            {children}
        </div>
    );
};

/**
 * Form Section Component
 */
Form.Section = function Section({ children }: PropsWithChildren<{}>) {
    return <div className="form__section">{children}</div>;
};

/**
 * Form Section Component
 */
Form.SectionTitle = function Title({ children }: PropsWithChildren<{}>) {
    return <h3 className="form__section-title">{children}</h3>;
};

/**
 * Form Section Component
 */
Form.SectionSubtitle = function Title({ children }: PropsWithChildren<{}>) {
    return <h3 className="form__section-subtitle">{children}</h3>;
};

/**
 * Form Row Component
 */
Form.Row = function Row({
    children,
    className,
    verticalCenter,
}: PropsWithChildren<{ className?: string; verticalCenter?: boolean }>) {
    return (
        <div
            className={`form__row ${className} ${
                verticalCenter === true ? " form__row--vertical-center" : ""
            }`}
        >
            {children}
        </div>
    );
};

/**
 * Form Row Responsive Component
 */
Form.RowColResponsive = function RowColResponsive({
    children,
    className,
}: PropsWithChildren<{ className?: string }>) {
    return <div className={`form__row-column-responsive ${className}`}>{children}</div>;
};

/**
 * Form Row Component
 */
Form.ButtonRow = function ButtonRow({
    children,
    className,
}: PropsWithChildren<{ className?: string }>) {
    return <div className={`form__button-row ${className}`}>{children}</div>;
};
